Ext.define('SA.model.createimport.FileTupleList', {
    constructor(tuples) {
        this.tuples = tuples;
    },

    filter(callback) {
        return this.tuples.filter(callback);
    },

    forEach(callback) {
        return this.tuples.forEach(callback);
    },

    getFileCount() {
        return this.getFiles().length;
    },

    getFiles() {
        return this.map(tuple => tuple.getFile()).filter(file => !file.isNull());
    },

    getHeaderNames() {
        var nameArrays = this.map(tuple => tuple.getHeaderNames()),
            names = Ext.Array.flatten(nameArrays);

        return Ext.Array.unique(names);
    },

    getTupleCount() {
        return this.getTuples().length;
    },

    getTuples() {
        return this.tuples;
    },

    getUnits() {
        return this.map(tuple => tuple.getUnit());
    },

    map(callback) {
        return this.tuples.map(callback);
    },

    serializeForRequest() {
        return this.map(tuple => tuple.serializeForRequest());
    },

    serializeForReview() {
        return this.map(tuple => tuple.serializeForReview());
    },

    setColumnDefinitions(columnDefinitions) {
        this.forEach(tuple => tuple.setColumnDefinitions(columnDefinitions));
    },

    some(callback) {
        return this.tuples.some(callback);
    }
});